import { getAllByElementId } from '@/api/pieceJointes/index';

export default async function getLogo(id) {
  const response = await getAllByElementId(id);
  const logo = response.data.result.items.find(p => p.placeType === 'Logo');
  return logo ? (logo.cheminMin || logo.chemin) : null;
}

export async function getFullLogo(id) {
  const response = await getAllByElementId(id);
  const logo = response.data.result.items.find(p => p.placeType === 'Logo');
  return logo ? (logo.chemin || logo.cheminMin) : null;
}
